import { ChipsideComponent } from "../chipside-component";

export class Label extends ChipsideComponent {
	constructor() {
		super();

		this.type = this.getAttribute("type") ?? "";

		if (this.type === "secondary") {
			this.classList.add("input-field__helper-text");
		} else {
			this.classList.add("input-field__label");
		}
	}
}